export enum Language {
  PL = "pl",
  EN = "en",
  ES = "es",
  KA = "ka"
}
